import { createAction, props } from '@ngrx/store';

import { UserLite } from '@lockton-apps/shared/interfaces';

import { DashboardBrokerLsosActionTypes } from './actions.model';

export const init = createAction(DashboardBrokerLsosActionTypes.Init);

export const tabIndexChanged = createAction(
  DashboardBrokerLsosActionTypes.TabIndexChanged,
  props<{ index: number }>()
);

export const policiesFilterChanged = createAction(
  DashboardBrokerLsosActionTypes.PoliciesFilterChanged,
  props<{ filter: Record<string, any> }>()
);

export const quotesFilterChanged = createAction(
  DashboardBrokerLsosActionTypes.QuotesFilterChanged,
  props<{ filter: Record<string, any> }>()
);
